var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "va-row" }, [
    _c(
      "div",
      { staticClass: "flex md12 xs12" },
      [
        _c(
          "vuestic-widget",
          { staticClass: "no-padding no-v-padding" },
          [
            _c("vuestic-breadcrumbs", {
              attrs: {
                breadcrumbs: _vm.breadcrumbs,
                currentRouteName: _vm.currentRouteName,
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }